export default [
  {
    path: '/activities_system_setting',          //首页
    component: (resolve) => require(['@/views/activities_system_setting/home/home'], resolve),
    hidden: true,
    meta: {
      title: 'global.users',
      code: 'activities_system_setting',
    },
    children: [
      {
        path: '/',        //系统首页
        component: resolve => require(['@/views/home_page/home_page'], resolve),
        meta: {
          title: '首页',
          code: 'activities_system_setting',
        }
      },
      {
        path: 'home_page',        //系统首页
        component: resolve => require(['@/views/home_page/home_page'], resolve),
        meta: {
          title: '首页',
          code: 'activities_system_setting',
        }
      },
      {
        path: 'user_management',        //用户管理
        component: resolve => require(['@/views/activities_system_setting/activities_system_user_mgr/activities_system_user_mgr'], resolve),
        meta: {
          title: 'global.users',
          code: 'activities_system_mgr',
        }
      },
      {
        path: 'role_management',         //角色管理
        component: resolve => require(['@/views/activities_system_setting/activities_system_role_mgr/activities_system_role_mgr'], resolve),
        meta: {
          title: 'global.roles',
          code: 'activities_system_role',
        }
      },
      {
        path: 'dept_management',         //部门管理
        component: resolve => require(['@/views/activities_system_setting/activities_system_dept_mgr/activities_system_dept_mgr'], resolve),
        meta: {
          title: 'global.depts',
          code: 'activities_system_dept',
        }
      },
      {
        path: 'sys_run_log',         //运行日志
        component: resolve => require(['@/views/activities_system_setting/sys_run_log/index'], resolve),
        meta: {
          title: 'global.log',
          code: 'sys_run_log',
        }
      },
      {
        path: 'auditor_log',         //审计员日志
        component: resolve => require(['@/views/activities_system_setting/auditor_log/index'], resolve),
        meta: {
          title: 'global.auditorLog',
          code: 'auditor_log',
        }
      },
      {
        path: 'user_operation_log',         //用户操作日志
        component: resolve => require(['@/views/activities_system_setting/user_operation_log/index'], resolve),
        meta: {
          title: 'global.auditorLog',
          code: 'user_operation_log',
        }
      },
      {
        path: 'mobile_user_log',         //小程序用户操作日志
        component: resolve => require(['@/views/activities_system_setting/mobile_user_log/index'], resolve),
        meta: {
          code: 'mobile_user_log',
        }
      },
      {
        path: 'sys_security_config',         //系统安全配置
        component: resolve => require(['@/views/activities_system_setting/sys_security_config/index'], resolve),
        meta: {
          title: 'global.auditorLog',
          code: 'sys_security_config',
        }
      },
      {
        path: 'sys_admin_log',         //系统管理员日志
        component: resolve => require(['@/views/activities_system_setting/sys_admin_log/index'], resolve),
        meta: {
          title: 'global.auditorLog',
          code: 'sys_admin_log',
        }
      },
      {
        path: 'secrecy_admin_log',         //安全保密管理员日志
        component: resolve => require(['@/views/activities_system_setting/secrecy_admin_log/index'], resolve),
        meta: {
          title: 'global.auditorLog',
          code: 'secrecy_admin_log',
        }
      },
      {
        path: 'functional_dept',         //职能部门
        component: resolve => require(['@/views/activities_system_setting/functional_dept/index'], resolve),
        meta: {
          title: 'global.functional_dept',
          code: 'functional_dept',
        }
      },
      {
        path: 'device_channel',         //设备通道
        component: resolve => require(['@/views/activities_system_setting/device_channel/index'], resolve),
        meta: {
          title: 'global.device_channel',
          code: 'device_channel',
        }
      },
      // /activities_system_setting/position_management
      {
        path: 'position_management',           //职位管理
        component: resolve => require(['@/views/system_setting/position_management/position_management'], resolve),
        meta: {
          title: 'global.position_management',
          code: 'position_management',
        }
      },
      {
        path: 'audit_user_mgr',
        component: resolve => require(['@/views/activities_system_setting/audit_user_mgr/index'], resolve),
        meta: {
          title: 'global.audit_user_mgr',
          code: 'audit_user_mgr',
        }
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/module/activities_system_setting.js